import { render } from "./presc_create_page.vue?vue&type=template&id=e975eac6"
import script from "./presc_create_page.vue?vue&type=script&lang=js"
export * from "./presc_create_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__